<template>
  <v-container fill-height align-start>
    <v-row no-gutters>
      <v-col cols="12" :key="index">
        <!-- <button @click="fillData()">Randomize</button> -->
        <v-data-table :headers="headers" :items="people" item-key="_key" class="elevation-1" :search="search" :loading="!loaded" loading-text="Loading... Please wait">
          <template v-slot:top>
            <v-card flat>
              <!-- <v-row>
                <v-col cols="12">
                    <earnings-bar-chart v-if="loaded" :chart-data="datacollection" :styles="{height: '250px', position: 'relative'}"></earnings-bar-chart>
                </v-col>
              </v-row> -->

              <v-card-title>
                <span>Total Payments: ${{
                    (
                      parseFloat(userProfile.directPaymentsTotal||0) +
                      parseFloat(userProfile.comPaymentsTotal||0)
                    ).toFixed(2)
                  }}</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-subtitle>
                <v-row>
                  <v-col cols="12">
                    <span>Direct: ${{ userProfile.directPaymentsTotal }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span>Commissions: ${{ userProfile.comPaymentsTotal }}</span>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </template>
          <template v-slot:item.rating="{item}">
            <v-row align="baseline">
              <v-col cols="12">
                <v-rating background-color="grey" :color="getColor(item.rating)" small dense v-model="item.rating" readonly></v-rating>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// import EarningsBarChart from '@/components/obrero/EarningsBarChart'

const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    // EarningsBarChart
  },
  data () {
    return {
      loaded: false,
      datacollection: null,
      flat: {},
      search: '',
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name'
        },
        { text: 'Enrollment', value: 'enrollment' },
        { text: 'Role', value: 'role' },
        { text: 'Level', value: 'level' },
        { text: 'Agent', value: 'parentName' },
        { text: 'Jobs', value: 'completedJobs' },
        { text: 'Rating', value: 'rating' },
        { text: 'Commissions', value: 'commissionTotal' }
      ],
      people: [],
      index: 0,
      loading: true,
      profileObjs: {}
    }
  },
  mounted: function () {
    this.loaded = false

    this.flat = (this.userProfile || {}).referrals || {}
    // if (this.userProfile.referrals !== undefined) {
    //   var referrals = (this.userProfile || {}).referrals
    //   Object.keys(referrals).map(k => {
    //     if (referrals[k].stripe_user_id) {
    //       referrals[k].enrollment = 'Complete'
    //       if (referrals[k].stripe_user_id[0] === 'c') {
    //         referrals[k].role = 'Hire'
    //       } else {
    //         referrals[k].role = 'Work'
    //       }
    //     } else {
    //       referrals[k].enrollment = 'Pending'
    //     }
    //   })
    // }
  },
  computed: {
    ...mapState([
      'userProfile',
      'currentUser',
      'userJobs',
      'userPayments'
    ])
  },

  methods: {
    fillData () {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: 'primary',
            data: [this.getRandomInt(), this.getRandomInt()]
          }, {
            label: 'Data One',
            backgroundColor: 'primary',
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
      this.loaded = true
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    getColor (statusColor) {
      if (parseFloat(statusColor) > 4) {
        return 'green'
      } else if (parseFloat(statusColor) > 3) {
        return 'yellow'
      } else {
        return 'red'
      }
    },
    async map () {
      return Promise.all(
        Object.keys(this.flat).map((k) => {
          return fb.database
            .ref(`/user/${k}/profile/public`)
            .once('value')
            .then((snapshot) => {
              var profile = snapshot.val()
              if (this.flat[k] === true) {
                this.flat[k] = {}
              }
              this.flat[k].name = profile.name
              this.flat[k].rating = profile.rating
              this.flat[k].completedJobs = profile.completedJobs
              this.flat[k]._key = k
              if (this.flat[k].stripe_user_id) {
                this.flat[k].enrollment = 'Complete'
                if (this.flat[k].stripe_user_id[0] === 'c') {
                  this.flat[k].role = 'Hire'
                  this.flat[k].agent = 'No'
                } else {
                  this.flat[k].role = 'Work'
                }
              } else {
                this.flat[k].enrollment = 'Pending'
                this.flat[k].agent = 'No'
              }
              this.profileObjs[k] = this.flat[k]
            })
            .catch((err) => {
              console.log(err)
            })
        })
      )
    }
  },
  watch: {

    flat () {
      this.map()
        .then(() => {
          Object.keys(this.profileObjs).map((k) => {
            if (this.profileObjs[this.profileObjs[k].parent] !== undefined) {
              this.profileObjs[k].parentName = this.profileObjs[this.profileObjs[k].parent].name
            } else {
              this.profileObjs[k].parentName = 'You'
            }
            this.people.push(this.profileObjs[k])
          })
        })
        .then(() => {
          this.loaded = true
        })
    }
  },
  filters: {
    svgURL (val) {
      return `@assets/${val}`
    },
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    }
  }
}
</script>
<style>
li a {
  text-decoration: none;
}
</style>
